import { useState } from "react"
import { api, ApiError } from "../../lib/api"
import Modal from "../Modal"

type Props = {
  onClose: () => void
  onCreated: (newOrgId: number) => void
}

const CreateOrganizationModal = ({ onClose, onCreated }: Props) => {
  const [name, setName] = useState("")
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return
    setSaving(true)
    setError(null)
    try {
      const data = await api.post<{ organization: { id: number } }>(
        "/organizations",
        { organization: { name: name.trim() } }
      )
      onCreated(data.organization.id)
    } catch (err) {
      const { data: errData } = err as ApiError
      setError(errData.errors?.join(", ") ?? "作成に失敗しました")
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      title={<><i className="bi bi-building" />組織を作成</>}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn-secondary" onClick={onClose}>キャンセル</button>
          <button
            type="submit"
            form="create-org-form"
            className="btn-primary"
            disabled={saving || !name.trim()}
          >
            <i className="bi bi-check-lg" />
            {saving ? "作成中..." : "作成する"}
          </button>
        </>
      }
    >
      {error && <div className="settings-alert settings-alert--error">{error}</div>}
      <form id="create-org-form" onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="new-org-name">組織名</label>
          <input
            id="new-org-name"
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="例: 株式会社〇〇"
            autoFocus
          />
        </div>
      </form>
    </Modal>
  )
}

export default CreateOrganizationModal
